import { apiService } from './apiService';
import { userEndpoints } from '../api/apiEndpoint';
import { DefaultResponse } from '@/common/types/common';

/**
 * 비밀번호 변경 상태 응답 DTO
 */
export interface ChangePasswordStatusDto {
  isExpired: boolean;
  isCompleted: boolean;
}

/**
 * 비밀번호 변경 정보 응답 DTO
 */
export interface ChangePasswordInfoDto {
  changePasswordId: number;
  userName: string;
  phone: string;
  loginId: string;
  expiredAt: string;
}

/**
 * 비밀번호 변경 요청 DTO
 */
export interface ChangePasswordRequestDto {
  newPassword: string;
  userCi: string;
  userDi: string;
  token: string;
  changePasswordToken: string;
}

/**
 * 비밀번호 변경 관련 서비스
 */
export const changePasswordService = {
  /**
   * 비밀번호 변경 토큰 상태 확인
   * @param token URL에서 받은 토큰
   * @returns 토큰 상태 (만료 여부, 완료 여부)
   */
  async checkStatus(token: string): Promise<ChangePasswordStatusDto | null> {
    try {
      const response = await apiService.get<ChangePasswordStatusDto>(
        userEndpoints.getChangePasswordStatus(token)
      );
      return response;
    } catch (error) {
      console.error('비밀번호 변경 상태 확인 실패:', error);
      return null;
    }
  },

  /**
   * 비밀번호 변경 정보 조회
   * @param token URL에서 받은 토큰
   * @returns 비밀번호 변경 정보 (사용자명, 전화번호, 로그인ID, 만료일)
   */
  async getInfo(token: string): Promise<ChangePasswordInfoDto | null> {
    try {
      const response = await apiService.get<ChangePasswordInfoDto>(
        userEndpoints.getChangePasswordInfo(token)
      );
      return response;
    } catch (error) {
      console.error('비밀번호 변경 정보 조회 실패:', error);
      return null;
    }
  },

  /**
   * 비밀번호 변경 요청
   * @param data 비밀번호 변경 요청 데이터
   * @returns 성공 여부
   */
  async changePassword(data: ChangePasswordRequestDto): Promise<DefaultResponse | null> {
    try {
      const response = await apiService.post<DefaultResponse>(
        userEndpoints.changePassword(),
        data
      );
      return response;
    } catch (error) {
      console.error('비밀번호 변경 실패:', error);
      return null;
    }
  }
};
